import {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../../store/reducers/preferences';
import {useTranslation} from 'react-i18next';
import {FormControlLabel, FormLabel, RadioGroup} from '@mui/material';
import Radio from '@mui/material/Radio';
import {isNull} from 'lodash';

const DEFAULT_STATE = {
    formActionBarMode: 'top',
};

const FormActionBarMode = forwardRef((props, ref) => {
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [mode, setMode] = useState(!isNull(agylePreference?.formActionBarMode) ? agylePreference?.formActionBarMode : DEFAULT_STATE.formActionBarMode);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setMode(DEFAULT_STATE.formActionBarMode);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (_e, val) => {
        setMode(val);
        props.onChange('formActionBarMode', val);
    };

    return (
        <div>
            <FormLabel>
                {t('Select the default behaviour of action bar on full form')}
            </FormLabel>

            <RadioGroup
                value={mode}
                row
                onChange={handleChange}
            >
                <FormControlLabel
                    value="top"
                    control={<Radio/>}
                    label={t('Only on top')}
                />

                <FormControlLabel
                    value="withBottom"
                    control={<Radio/>}
                    label={t('Top and dynamic bottom')}
                />
            </RadioGroup>
        </div>
    );
});

export default FormActionBarMode;
